/**
 * Simple logger factory for client-side components and workers.
 *
 * Precondition: name is a non-empty string identifying the component/worker
 * Postcondition: Returns a Logger object with debug, log, warn, error methods
 * Invariant: All log messages are prefixed with [name]
 */

interface Logger {
  debug: (...args: unknown[]) => void;
  log: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

export function createLogger(name: string): Logger {
  const prefix = `[${name}]`;
  return {
    debug: (...args) => console.debug(prefix, ...args),
    log: (...args) => console.log(prefix, ...args),
    warn: (...args) => console.warn(prefix, ...args),
    error: (...args) => console.error(prefix, ...args),
  };
}
